import createIcon from '../../createIcon';

/**
 * @component @name AlignHorizontalCenter
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTEgMkgxM1Y3SDIxVjEwSDEzVjE0SDE4VjE3SDEzVjIySDExVjE3SDZWMTRIMTFWMTBIM1Y3SDExVjJaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const AlignHorizontalCenter = createIcon('AlignHorizontalCenter', [
  ['path', { d: 'M11 2H13V7H21V10H13V14H18V17H13V22H11V17H6V14H11V10H3V7H11V2Z', key: '2magny' }],
]);

export default AlignHorizontalCenter;
